<template>
    <div class="map-popup">
        <h4
            class="is-size-4 has-text-weight-medium"
        >
            {{ title }}
            <button
                class="delete is-small"
                @click="$emit('close-popup')"
            />
        </h4>
        <h6
            v-if="subtitle"
            class="is-size-6"
        >
            {{ subtitle }}
        </h6>
        <div class="popup-content content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'MapPopup',

    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
            required: false,
        },
    },

};
</script>

<style lang="scss">
    .map-popup {
        $dialogue-secondary: #aaa !default;
        $light: #f5f5f5 !default;
        $primary-light: #533d32 !default;

        position: relative;
        border: 1px solid transparent; // maintain box padding
        min-width: 20em;
        background: $primary-light;

        h4 {
            font-weight: 900;
            background: $primary-light;
            color: $light;
            margin: 1.25rem 1.9rem 0.65rem 1.25rem;
            position: relative;

            button.delete {
                position: absolute;
                right: -1.25rem;
                top: -0.6rem;
            }
        }

        h6 {
            font-weight: 700;
            background: $dialogue-secondary;
            color: #222;
            padding: 0.5em 0.59em;
            border-left: 0.66rem solid $primary-light;
            border-right: 0.66rem solid $primary-light;
        }

        .popup-content {
            margin: 0.65rem 1.25em 1.25rem 1.25rem;
            color: $light;
        }
    }
</style>
